import { useTimezone } from '@app/core/hooks/useTimezone';
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';
import { Box, Tooltip } from '@mui/material';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { usePartialSegmentCoverage } from '../../../../hooks/segments/usePartialSegmentCoverage';

const partialSegmentCoverageTooltipMessage = defineMessage({
  id: 'logger.streamScreen.controls.partialSegmentCoverage.tooltip',
  defaultMessage:
    'No hay emisión disponible para todo el rango seleccionado. Solo se muestra la parte del rango en la que hubo transmisión. (Rango disponible: {fromTime} - {toTime})',
});

/**
 * Warning shown when the API returns segments that do not fully cover the requested range.
 */
export function PartialSegmentCoverageWarning() {
  const { $t } = useIntl();
  const tz = useTimezone();
  const { hasPartialCoverage, segmentsRange } = usePartialSegmentCoverage();

  const tooltipTitle = useMemo(() => {
    if (!segmentsRange) {
      return '';
    }

    const zone = tz ?? 'UTC';
    const fromTime = DateTime.fromMillis(segmentsRange.from, { zone }).toFormat('HH:mm');
    const toTime = DateTime.fromMillis(segmentsRange.to, { zone }).toFormat('HH:mm');

    return $t(partialSegmentCoverageTooltipMessage, { fromTime, toTime });
  }, [segmentsRange, tz, $t]);

  if (!hasPartialCoverage) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          color: 'warning.main',
        }}
      >
        <ReportOutlinedIcon fontSize="small" />
      </Box>
    </Tooltip>
  );
}
